<script>
import { mapActions, mapGetters } from "vuex";

import vDatePicker from "v-calendar/lib/components/date-picker.umd";

import orderSchedulerHelper from "@/utils/helpers/orderSchedulerHelper";
import specialDatesHelper from "@/utils/helpers/specialDatesHelper";
import dateHelper from "@/utils/helpers/dateHelper";

export default {
  components: {
    vDatePicker
  },

  data() {
    return {
      selectedDay: null
    };
  },

  methods: {
    ...mapActions("orderScheduler", [
      "setDate",
      "unsetScheduleEvent",
      "requestProfessionalsAvailable"
    ]),

    setDefaultSelectedDay() {
      if (this.date) {
        this.selectedDay = this.date;
      }
    },

    setSelectedDay(selectedDay) {
      if (selectedDay.isDisabled) {
        return;
      }

      if (!dateHelper.isSameDate(selectedDay.date, this.date)) {
        this.setDate(selectedDay.date);
        this.$emit("dateSelected");
      } else {
        this.setDate(null);
      }

      this.unsetScheduleEvent();
      this.requestProfessionalsAvailable();
    }
  },

  computed: {
    ...mapGetters("orderScheduler", ["date", "address"]),

    fromDate: function() {
      return orderSchedulerHelper.fromDate();
    },

    toDate: function() {
      return orderSchedulerHelper.toDate();
    },

    disabledDates: function() {
      return specialDatesHelper.daysWithDisabledPurchase(this.city);
    },

    city: function() {
      return (
        this.address &&
        this.address.district &&
        this.address.district.city &&
        this.address.district.city.display_name
      );
    }
  },

  mounted() {
    this.setDefaultSelectedDay();
  }
};
</script>

<template>
  <div class="calendar">
    <v-date-picker
      color="purple"
      :masks="{ weekdays: 'WWW' }"
      locale="pt-BR"
      is-inline
      is-expanded
      :columns="1"
      :min-date="fromDate"
      :max-date="toDate"
      :from-date="selectedDay"
      :disabled-dates="disabledDates"
      :v-model="selectedDay"
      :value="selectedDay"
      @dayclick="setSelectedDay"
      :first-day-of-week='1'
    />
  </div>
</template>

<style scoped>
.calendar {
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
}

.calendar * {
  border-radius: 0;
}

.calendar >>> .vc-title {
  font-weight: 400;
  text-transform: capitalize;
}

.calendar >>> .vc-weekday {
  font-weight: 400;
  text-transform: capitalize;
  font-size: 12px;
}

.calendar >>> .vc-day-content {
  font-weight: 400;
  text-transform: capitalize;
}

.calendar >>> .vc-bg-purple-600 {
  background-color: #603285;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalFilters/DatePicker.vue